export class ParameterValue {
  Name: string;
  Value?: any;
  PublicName?: string;

  constructor(name: string, value?: any, publicName?: string) {
    this.Name = name;
    this.Value = value;
    this.PublicName = publicName;
  }
}
